import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getUsersListCSV = () => {
  const url = `${apiConstants?.BASE_URL_1}/api/v1/User/GetAllActiveUsers`;
  const encodedUrl = encodeURIComponent(url);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.USER_MANAGEMENT.GET_USERS_LIST_CSV(encodedUrl)
  );
};

export default getUsersListCSV;
